export const selectFormDataValuesSelector = (state) => state?.formData;

export const selectSessionReduxDataSelector = (state) => {
    const keysToStoreData = [
        "registration",
        "registrationAccount",
        "teams",
        "raceConditions",
        "existingRegistrations",
        "parentRegistration",
    ];

    const sessionStorageReduxData = {};
    keysToStoreData.forEach((key) => {
        sessionStorageReduxData[key] = state[key];
    });

    return sessionStorageReduxData;
};
